import {
  GET_ALL_JACKPOTS,
  GET_ALL_JACKPOTS_RESPONSE_SUCCESS,
} from "./actionTypes";

export const getAllJackpots = () => {
  return {
    type: GET_ALL_JACKPOTS,
  };
};
export const getAllJackpotsResponseSuccess = (payload) => ({
  type: GET_ALL_JACKPOTS_RESPONSE_SUCCESS,
  payload: payload,
});
